import { Stack, Typography, useTheme } from "@mui/material";

import { imageSource, Strings } from "@app/constants";
import { useResponsive } from "@app/hooks";

const NavbarLogo = () => {
  const isMobile = useResponsive("down", "sm");
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      justifyContent={isMobile ? "flex-end" : "space-between"}
      alignItems="center"
      height={"100%"}
      sx={{
        backgroundColor: theme.palette.primary.main,
        px: 3,
        py: 1,
        overflow: "hidden",
        borderBottomRightRadius: 35,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        gap={2}
        sx={{
          fontWeight: 500,
          // color: theme.palette.common.white,
          width: 175,
          fontSize: { sm: 15, md: 20 },
        }}
      >
        {/* <img
          alt="logo"
          src={imageSource.logo}
          style={{ width: 35, height: 35, objectFit: "contain" }}
        />  */}
        <img
          alt="logo"
          loading="lazy"
          src={imageSource.navBarLogo}
          style={{
            width: 128,
            height: 128,
            objectFit: "contain",
          }}
        />
        {/* <Typography
          variant="h6"
          sx={{
            fontWeight: 500,
            color: theme.palette.common.white,
            width: 155,
            fontSize: { sm: 15, md: 20 },
          }}
        >
          {Strings.common.kaizenMoter}
        </Typography> */}
      </Stack>
    </Stack>
  );
};

export { NavbarLogo };
